<template>
  <div class="context-editor-wrap" :class="{ 'data-changed': dataChanged }">
    <a ref="trigger1">
      <input
        v-model="localValue"
        ref="context-input"
        class="context-input"
        :placeholder="$t('autogenerated.context-editor.enterContext')"
        :readonly="!localIsEditingContext"
        @click="onWrapTouched"
        @keydown.meta.13="onConfirm"
        @keyup.esc="onDecline"
        @blur="onBlur"
      />
    </a>
    <or-popover ref="autocomplete" trigger="trigger1" class="popover">
      <or-menu
        class="context-menu"
        :options="allApplicationNames"
        @select="onApplicationSelect"
      />
    </or-popover>
    <div v-if="localIsEditingContext" class="btns-wrap">
      <or-icon-button
        class="flat"
        icon="close"
        type="secondary"
        size="small"
        @click.stop="onDecline"
      />
      <or-icon-button
        class="flat"
        icon="check"
        type="secondary"
        size="small"
        @click.stop="onConfirm"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapActions } from 'vuex'

export default {
  created () {
    this.localValue = _.clone(this.$props.value)
  },

  props: {
    value: String,
    isEditingContext: Boolean,
    isLoading: Boolean
  },

  computed: {
    ...mapState('knowledgebase', ['allApplications']),

    allApplicationNames () {
      return _.uniq(_.map(this.allApplications, 'name'))
    },

    localIsEditingContext: {
      get () {
        return this.isEditingContext
      },
      set (value) {
        this.$emit('update:isEditingContext', value)
      }
    },

    dataChanged () {
      if (this.$props.isLoading) return false

      return (
        this.localValue !== this.$props.value && !this.localIsEditingContext
      )
    }
  },

  data () {
    return {
      localValue: ''
    }
  },

  methods: {
    ...mapActions('knowledgebase/notifications', ['addWarning']),

    onWrapTouched () {
      this.localIsEditingContext = true
      this.$refs['context-input'].focus()
    },

    onApplicationSelect (value) {
      this.localValue = value
      this.$refs.autocomplete.close()
      this.onConfirm()
    },

    onBlur () {
      setTimeout(() => {
        this.localIsEditingContext = false
      }, 500)
    },

    onDecline () {
      this.localValue = _.clone(this.$props.value)
      this.$refs.autocomplete.close()
      this.localIsEditingContext = false
    },

    onConfirm () {
      this.$emit('save', this.localValue)
      this.localIsEditingContext = false
    }
  },

  watch: {
    dataChanged (value) {
      if (value) {
        this.addWarning({
          title: this.$t('autogenerated.context-editor.exitWarning')
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.context-menu.ui-menu {
  max-height: 126px;
  overflow: scroll;
}

.context-editor-wrap {
  position: relative;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  padding: $sp-2;

  &.data-changed {
    background-color: lighten($or-yellow, 35%);
  }

  &:hover {
    cursor: pointer;
  }

  .context-input {
    width: 100%;
    height: 24px;
    border: none;
    outline: none;
    font-size: 14px;
    color: $or-black-blue;
    background: none;
  }

  .btns-wrap {
    display: flex;
    justify-content: flex-start;
    width: 40px;
  }
}
</style>
